import { CreativityContentData } from 'src/types/banner';
import { BannerMetadataLine } from 'src/types/library-metadata';
import { capitalize, getBannerDate } from 'src/utils';

export const getBannerMetadata = (creativity: CreativityContentData): BannerMetadataLine[] => {
  const { config, title } = creativity;
  const lines: BannerMetadataLine[] = [];

  const hasTeams = config && 'team1' in config && 'team2' in config && config.team1 && config.team2;
  const hasRound = config && 'round' in config && config.round;

  // Primera línea: equipos
  if (hasTeams) {
    lines.push({
      text: `${capitalize(config.team1)} vs ${capitalize(config.team2)}`,
      fontWeight: 'bold'
    });
  } else {
    lines.push({
      text: title || 'Asset',
      fontWeight: 'bold'
    });
  }

  // Segunda línea: ronda
  if (hasRound) {
    lines.push({
      text: `Ronda ${config.round}`
    });
  }

  // Fecha al final
  const dateText = getBannerDate(creativity);
  if (dateText) {
    lines.push({
      text: dateText,
      fontSize: 'base'
    });
  }

  return lines;
};
